import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Vinted'
        title="Vinted Sellers, Here's How You Can Boost Sales With Bundles"
      >
        <p>
          Known as an online marketplace for selling second-hand items, Vinted offers new features that can help you
          gain earnings consistently and quickly, as long as you know how to maximize them. With thousands of
          competitors or fellow sellers on the platform, you would have to market your items strategically. This is so
          potential buyers would flock to your account and hopefully make a purchase.
        </p>
        <p>
          Knowing the ins and outs may be overwhelming, but there are a couple of simple yet effective ways to boost
          your sales without having to research so much. These are creating Item Bundles and doing Item Bumps. With a
          few clicks and navigation through what sells fast on Vinted, you'd be one of those top users who keep closing
          sales even when this is only a part-time gig for you.
        </p>

        <h3>Ways to sell a bundle</h3>
        <p>
          Creating a bundle of items from your Vinted closet means gathering certain pieces together and offering them
          for a discount. You get to sell a couple of items all at once on your end. From the buyer's end, this is
          something they want as well. They can get all the items they want from your wardrobe at a low price and can
          pay them all under one shipping fee. This saves them from postage costs; it's a win-win situation.
        </p>
        <p>
          There are two ways you can do this: one, create a separate listing for specific pieces, and two, allow buyers
          to create their bundle by gathering their favourite items from your listings.
        </p>
        <h4>Create a listing</h4>
        <p>
          When you want to offer bundles, there are some rules you should follow. First, you should create a proper
          title or label and description. Make it clear to users that there are a lot of items you are offering for a
          low price.
        </p>
        <p>
          Second, choose only one category that best fits the types of items. If you are selling different jewelry from
          different brands, it should be under "jewelry." If you are offering discounts on a top, a pair of jeans, and
          boots, then you can categorize them as "clothes."
        </p>
        <p>
          Third, take clear photos and upload several ones. Preferably, this should include an image with all the items
          in them and several other solo images of each piece. This way, buyers would know the exact items included in
          the bundle.
        </p>
        <p>
          Fourth, take note of the maximum limit of five (5) items. Make sure to weigh each one correctly, including
          your packaging, so when you set the price, it is reasonable, and buyers would get the overall bundle discount.
        </p>
        <p>
          Lastly, when you create the listing, you are not duplicating items. This means once you have registered an
          item for a bundle, you shouldn't include it in a separate listing. You do this to avoid two different buyers
          purchasing the same item. It is better to avoid such disputes rather than settling them and causing
          inconvenience to parties involved.
        </p>
        <h4>Allow buyers to create their own</h4>
        <p>
          When buyers go to the "Shop Bundles" section, they will press the "Shop Button" and navigate to the items they
          have "liked" from your account. Once they are ready, they will click "Request Bundle," and you will receive a
          notification about it.
        </p>
        <p>
          As a seller, you have the freedom to approve this request and choose the parcel size. Once both parties agree
          to the total cost, the buyer can now click the "Buy Button." There are buyer protection fees (5% of the price
          + 0.7 EURO) and the shipping price.
        </p>
        <p>
          However, if a particular item is no longer available, you can easily message the buyer to edit their bundle
          and request it afterward.
        </p>
        <p>
          There are times when the buyer will return a specific item. This can be because of several reasons such as the
          wrong size, a damaged part of the item, and similar. Even when the other items are in good condition, Vinted's{' '}
          <a href='https://www.vinted.co.uk/help/465'>Return Policy</a> states that the buyer must return all pieces and
          not simply a part of a bundle.
        </p>
        <p>
          You will have to issue a refund for the entire bundle cost as a seller. Depending on the negotiation between
          you and the buyer, you may also have to shoulder the return postage.
        </p>

        <h3>Boosting your sales</h3>
        <p>
          Aside from selling some of your items at low prices, you can also boost earnings by doing an Item Bump. This
          is Vinted's automated paid feature that allows you to "bump" your listings. In turn, more platform users will
          come across them, especially when it is tailored according to a specific category or brand.
        </p>
        <p>
          Before you order or subscribe, make sure that your target listings comply with the{' '}
          <a href='https://www.vinted.co.uk/catalog-rules'>quality control</a> of Vinted. When needed, edit your listing
          accordingly.
        </p>
        <p>
          Once you are all set, you can click the "Bump" button on a specific listing. This automatically makes it to
          the top of the platform's searches for brands or categories. You can see the statistics or the overview of how
          many times users have interacted with your listing or account. In this way, you will know which items are more
          attractive and how you can edit your other "un-bumped" items.
        </p>
        <p>
          Click <a href='https://www.vinted.co.uk/pricelist'>here</a> to see the Price List of Item Bump.
        </p>
        <p>
          If you want to further increase your sales by expanding your reach, you can avail yourself of third-party apps
          like OneShop. This helps you relist your items across other popular online marketplaces like Poshmark and
          Mercari. It automatically cross-posts and also delists once a particular item has been sold.
        </p>
        <p>
          Using such an app makes it easier for you, as a seller, to navigate marketing. All you need is a few clicks,
          and you can leave these apps and great features to help you out.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
